import { signal } from '@angular/core';
import { IcingSvgComponent } from './icing-svg/icing-legend-svg';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';

export const ICING_LEGEND: TwcLegendParams = {
  title: 'ICING',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: IcingSvgComponent },
  legendComponent: TwcLegendComponent
};
